const SummaryOfBenefitsConstants = {
  title: 'Plan Documentation',
  ARCHIVED: 'Archived Plan Documents',
  subTitle:
    'Access Your Summary Plan Descriptions and Benefits Summaries Here.',
  tabs: [
    'Summary Plan Description',
    'Summary of Benefits',
    'Exclusion Analysis',
    'Coverage Check',
    'Reports',
  ],
  viewReport: 'View Review Report',
  SPD_REPORT_CATEGORIES: [
    {
      category: 'Fundamental Reports',
      reports: ['ERISA Regulatory Compliance Check'],
    },
    {
      category: 'Inter Contract Compliance Reports',
      reports: [
        'Comparison with PBM Service Agreement',
        'Comparison with Administrative Service Agreement',
        'Comparison with Network Carrier Agreement',
        'Gap Analysis',
      ],
    },
  ],
  ARCHIVE_PLAN_DOC: {
    TITLE: 'Archive Plan Document',
    SUB_TITLE:
      'On confirmation, this plan document will be Archived. Are you sure you want to proceed?',
  },
  DELETE_PLAN_DOC: {
    TITLE: 'Delete Plan Document',
    SUB_TITLE:
      'On confirmation, this plan document will be permanently deleted. You can choose to archive it from the menu instead. Are you sure you want to proceed?',
  },
  REGENERATE_METADATA: 'Regenerate Metadata',
};

export default SummaryOfBenefitsConstants;
